import React from 'react';
import { Grid, Card, CardMedia, CardContent, Typography, Box } from '@mui/material';

interface Dress {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  availableDate: string;
  location: string;
}

interface DressingGridProps {
  dresses: Dress[];
}

const DressingGrid: React.FC<DressingGridProps> = ({ dresses }) => {
  return (
    <Grid container spacing={3}>
      {dresses.map((dress) => (
        <Grid item xs={12} sm={6} md={4} key={dress.id}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardMedia
              component="img"
              height="200"
              image={dress.imageUrl}
              alt={dress.title}
              sx={{ objectFit: 'cover' }}
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography gutterBottom variant="h6" component="div">
                {dress.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {dress.description}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 'auto' }}>
                <Typography variant="body2" color="text.secondary">
                  {new Date(dress.availableDate).toLocaleDateString()}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {dress.location}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default DressingGrid; 